/* ALTON — collection toolbar: filter panel toggle + sort menu. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var filterToggle = e.target.closest ? e.target.closest('[data-filter-toggle]') : null;
    if (filterToggle) {
      e.preventDefault();
      var panel = document.getElementById('FilterPanel');
      var sign = filterToggle.querySelector('[data-filter-sign]');
      if (!panel) return;
      var open = panel.classList.toggle('open');
      panel.style.maxHeight = open ? panel.scrollHeight + 20 + 'px' : '0px';
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (sign) sign.textContent = open ? '–' : '+';
      return;
    }

    var sortToggle = e.target.closest ? e.target.closest('[data-sort-toggle]') : null;
    var sortMenu = document.querySelector('.sort-menu');
    if (sortToggle && sortMenu) {
      e.preventDefault();
      var isOpen = sortMenu.classList.toggle('open');
      sortToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
    if (sortMenu && sortMenu.classList.contains('open') && !sortMenu.contains(e.target)) {
      sortMenu.classList.remove('open');
      var t = sortMenu.querySelector('[data-sort-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sortMenu = document.querySelector('.sort-menu.open');
    if (sortMenu) sortMenu.classList.remove('open');
  });
})();
